import { MapPin, ArrowRight, Crown, Clock, Wine } from "lucide-react";

export const OutletCard = ({ outlet, language, t, index = 0 }) => {
  const description =
    language === "pl" ? outlet.description_pl : outlet.description_en;
  const isVip = outlet.zone === "vip";

  const handleClick = () => {
    window.open(outlet.menu_url, "_blank", "noopener,noreferrer");
  };

  const handleSpirits = (e) => {
    e.stopPropagation();
    window.open(outlet.spirits_menu_url, "_blank", "noopener,noreferrer");
  };

  const handleSpiritsKey = (e) => {
    e.stopPropagation();
  };

  return (
    <div
      data-testid={`outlet-card-${outlet.id}`}
      role="button"
      tabIndex={0}
      onClick={handleClick}
      onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") handleClick(); }}
      className="group bg-white rounded-2xl overflow-hidden shadow-sm border border-[#e8e8e8] flex flex-row active:scale-[0.98] transition-transform cursor-pointer text-left w-full animate-fade-in-up"
      style={{ animationDelay: `${index * 0.05}s` }}
    >
      {/* Thumbnail */}
      <div className="w-24 h-24 shrink-0 bg-gray-100 overflow-hidden relative">
        <img
          src={outlet.image_url}
          alt={outlet.name}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
          loading="lazy"
        />
        {isVip && (
          <div className="absolute top-1 left-1 bg-black/70 text-white p-1 rounded">
            <Crown size={10} />
          </div>
        )}
      </div>

      {/* Content */}
      <div className="flex-1 px-3 py-2.5 flex flex-col justify-between min-w-0">
        <div>
          <h3 className="text-sm font-bold text-[#000000] leading-tight truncate">
            {outlet.name}
          </h3>
          <p className="text-xs text-gray-500 flex items-center gap-1 mt-0.5">
            <MapPin size={10} className="text-[#dd260e] shrink-0" />
            <span className="truncate">{description}</span>
          </p>
          {outlet.name === "Restauracja Południowa" && (
            <span className="inline-flex items-center gap-0.5 text-[10px] font-medium text-[#dd260e] mt-1">
              <Clock size={10} />
              {t.event_only}
            </span>
          )}
          {outlet.spirits_menu_url && (
            <button
              data-testid="spirits-menu-btn"
              onClick={handleSpirits}
              onKeyDown={handleSpiritsKey}
              className="mt-1.5 inline-flex items-center gap-1 text-[11px] font-bold uppercase tracking-wide text-white bg-amber-700 px-3 py-1.5 rounded-full active:scale-95 transition-transform"
            >
              <Wine size={10} />
              {t.spirits_menu}
            </button>
          )}
        </div>
      </div>

      {/* Arrow */}
      <div className="flex items-center pr-3 shrink-0">
        <div className="w-8 h-8 rounded-full bg-[#f4f4f4] flex items-center justify-center group-hover:bg-[#dd260e] transition-colors">
          <ArrowRight size={14} className="text-gray-600 group-hover:text-white transition-colors" />
        </div>
      </div>
    </div>
  );
};
